import React, { Component } from 'react';

import { Image, Col, Form, Row, Container, Tabs, Tab, Button, Modal} from 'react-bootstrap';
import Tarjeta from '../../../../Images/IlustraciónBannerinicial_1.png'
import Tarjeta2 from '../../../../Images/IlustraciónBannerinicial_2.png'
import Translate from '../../../../translate'
import Jupiter from '../../../../Images/Jupiter.png'
import '../../../Landing/pages/components/Banner/index.css'

class PrincipalBanner extends Component {
    constructor(props) {
        super(props);
        this.state = { 
         }
    }

    render() {
        return (
          <div className='bannerBackground section-container' id='nosotros'>
            <div className='planetaDiv'>
                <Image src={Jupiter} className='jupiterImg'/>
              </div>
            <Container>
              <Row style={{marginTop:'80px'}}>
                  <Col md={12} lg={6} className="quitaespacios-container" >
                      <p className='bannerTitle'>{Translate[this.props.lan].card.banner.title}</p>
                      <p className='bannerSubtitle'>{Translate[this.props.lan].card.banner.subtitle}</p>
                      <div className='bannerInfoRow'>
                        <div className='elDivDelBotonDelBanner' >
                          {/*<Button className='main-button botonEnBanner' onClick={()=>this.props.scrollTo('formulario')}>¡Únete a Wirebit!</Button> */}
                          <Button className='main-button botonEnBanner' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[this.props.lan].card.banner.btn}</Button>
                        </div>
                      </div>
                  </Col>
                  <Col md={12} lg={6} className="laColumnaDelBannerImg quitaespacios-container" >
                      <Image src={this.props.lan == 'es' ?Tarjeta :Tarjeta2} className='banner-image' />
                  </Col>
              </Row>
            </Container>
          </div>
        );
    }
}

export default PrincipalBanner;
